export default "__VITE_ASSET__3f9076c7__"